import { stsOss } from '@api/oss'

export default {
  initApp (fullPath, module) {

    // 非app内点击拉起app
    const u = navigator.userAgent
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    if (isiOS) {

      let link
      if (module) {
        link = 'wxd.yaogongwang.com://*' + fullPath
      } else {
        link = 'wxd.yaogongwang.com://*'
      }
      // 尝试呼起 App
      window.location.href = link

      let fallback = 'https://itunes.apple.com/cn/app/id1611700524?mt=8'
      // 延迟跳转下载
      setTimeout(function () {
        window.location.href = fallback
      }, 5000)
      return
      // setTimeout(() => window.location.href = fallback, 3000);

      var timeout, t = 1000, hasApp = true
      setTimeout(function () {
        if (hasApp) {
          // 尝试呼起 App
          window.location.href = link
        } else {
          window.location.href = fallback
        }
        document.body.removeChild(ifr)
      }, 2000)

      var t1 = Date.now()
      var ifr = document.createElement('iframe')
      ifr.setAttribute('src', link)
      ifr.setAttribute('style', 'display:none')
      document.body.appendChild(ifr)
      timeout = setTimeout(function () {
        var t2 = Date.now()
        if (!t1 || t2 - t1 < t + 100) {
          hasApp = false
        }
      }, t)

    } else {

      // 安卓打开地址
      let scheme = `${process.env.VUE_APP_BASE_HOST}` + fullPath
      scheme = scheme.replace('https', 'yaogong')

      // 设置安卓下载地址
      let pkgsAndroid = 'market://details?id=com.szybkj.yaogong'

      // 招工找活的顶部标题栏
      let moduleText
      if (module === '招工') {
        moduleText = '找活'
        window.location.href = scheme + '&title=' + moduleText + '信息'
      } else if (module === '找活') {
        moduleText = '招工'
        window.location.href = scheme + '&title=' + moduleText + '信息'
      } else {
        moduleText = module
        window.location.href = scheme + '&title=' + moduleText
      }

      // // 如果是招工找活，携带标题栏
      // if (module) {
      //   window.location.href = scheme + '&title=' + moduleText + '信息'
      // } else {
      //   window.location.href = scheme
      // }

      // 延迟跳转下载
      setTimeout(function () {
        window.location.href = pkgsAndroid
      }, 3000)
    }
  },
  compareVersion(version1,version2){
    if(version1 === version2){
      return 0;
    }
    let verArr1 = version1.split(".");
    let verArr2 = version2.split(".");
    let maxflag = 1;
    let minLen = 0;
    if(verArr1.length > verArr2.length){
      minLen = verArr2.length;
    }else{
      minLen = verArr1.length;
      maxflag = 2;
    }
    for(var i = 0; i < minLen; i++){
      if(parseInt(verArr1[i]) - parseInt(verArr2[i]) > 0){
        return 1;
      }else if(parseInt(verArr1[i]) - parseInt(verArr2[i]) < 0){
        return -1;
      }
    }
    if(maxflag == 1){
      for (var j = minLen; j < verArr1.length; j++) {
        if(parseInt(verArr1[j]) > 0){
          return 1;
        }
      }
    }else{
      for (var k = minLen; k < verArr2.length; k++) {
        if(parseInt(verArr2[k]).intValue() > 0){
          return -1;
        }
      }
    }
    return 0;
  }
}

export const getRequest = () => {
  let url = location.search
  let theRequest = {}
  if (url.indexOf('?') !== -1) {
    let str = url.substr(1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}
// oss配置
let OSS = require('ali-oss')

export function client () {
  stsOss().then(res => {
    if (res.data.code === 200) {
      const data = res.data.data
      if (data) {
        let client = new OSS({
          region: 'oss-cn-shanghai',
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          bucket: 'yiyong-pub',
          stsToken: data.stsToken
        })
        return client
      }

    } else {
      this.$toastMsg(res.data.msg)
    }
  })
}
